"use client";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface ErrorStateProps {
  error: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ error }) => {
  const navigate = useNavigate();

  return (
    <div className="h-screen w-full bg-gradient-page dark:bg-gradient-page-dark flex items-center justify-center">
      <div className="text-center max-w-md">
        <h2 className="text-xl font-semibold text-foreground mb-2">
          Error Loading Template
        </h2>
        <p className="text-muted-foreground mb-6">{error}</p>
        <Button
          variant="default"
          size="default"
          onClick={() => navigate("/webbuilder/onboarding")}
        >
          Go Back
        </Button>
      </div>
    </div>
  );
};
